var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ENV } from '@/configurations/env';
import { IconLogo, IconLogoVariant } from '@agentguru/components';
import styles from './AppAgencyRoute.module.scss';
export function AppAgencyRoute() {
    return (_jsx("button", __assign({ type: "button", className: styles.container, onClick: function () { return window.open(ENV.APP_URL, '_blank'); } }, { children: _jsx(IconLogo, { variant: IconLogoVariant.agentGuruDark }) })));
}
